/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const originalTagMaxWidth = '180px';
const smallTagMaxWidth = '80px';
const mergePrDialogBranchNameMaxWidth = '97%';

export const BranchText = styled.span((props: { isFluidWidth: boolean }) => ({
  background: token('color.background.neutral', colors.N20A),
  borderRadius: token('border.radius', '3px'),
  color: token('color.text.subtle', colors.N500),
  display: 'inline-block',
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.medium'),
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 1,
  padding: `${token('space.050', '4px')} ${token('space.100', '8px')}`,
  verticalAlign: 'middle',
  '&:hover, &:focus': {
    backgroundColor: token('color.background.neutral.hovered', colors.N30A),
  },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  ...(props.isFluidWidth
    ? {
        maxWidth: mergePrDialogBranchNameMaxWidth,
        '@media (max-width: 600px)': {
          font: token('font.body.small'),
        },
      }
    : {
        maxWidth: originalTagMaxWidth,
        '@media (max-width: 600px)': {
          font: token('font.body.UNSAFE_small'),
          maxWidth: smallTagMaxWidth,
        },
      }),
}));
